import { render } from "./TicketCard.vue?vue&type=template&id=6295fa63"
import script from "./TicketCard.vue?vue&type=script&lang=js"
export * from "./TicketCard.vue?vue&type=script&lang=js"

import "./TicketCard.vue?vue&type=style&index=0&id=6295fa63&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__